import { AwardIcon, BookOpenIcon, FlameIcon, LanguagesIcon, MicIcon, TrophyIcon, ZapIcon, GlobeIcon } from "lucide-react";

export const achievements = [
  { id: "a1", title: "Week on fire", description: "7-day streak", icon: FlameIcon, earned: true },
  { id: "a2", title: "Polyglot pair", description: "Learn one language from two others", icon: LanguagesIcon, earned: true },
  { id: "a3", title: "Bookworm", description: "Finish 3 book chapters", icon: BookOpenIcon, earned: true },
  { id: "a4", title: "Loud & clear", description: "20 pronunciation wins", icon: MicIcon, earned: true },
  { id: "a5", title: "XP sprinter", description: "200 XP in a day", icon: ZapIcon, earned: false },
  { id: "a6", title: "Month on fire", description: "30-day streak", icon: TrophyIcon, earned: false },
  { id: "a7", title: "Globetrotter", description: "Start 5 course pairs", icon: GlobeIcon, earned: false },
  { id: "a8", title: "Word collector", description: "Master 100 saved words", icon: AwardIcon, earned: false },
];
